import React from 'react';
import Chart from 'react-apexcharts';
import { ChevronLeft, ChevronRight } from 'react-feather';
import { formatarNumero, nomeMes } from './UsinaResumoCards';

const COR_BARRA = '#f2a33c';
const COR_SELECIONADA = '#c97a11';

export default function UsinaGraficoDiario({ serie, referencia, diaSelecionado, estimadoMensal, onSelecionarDia, onNavegarMes, loading }: any) {
    const dados = serie || [];
    const total = dados.reduce((soma: number, item: any) => soma + (item.geracao || 0), 0);
    const estimadoDia = estimadoMensal > 0 ? Number((estimadoMensal / 30).toFixed(2)) : null;

    const series: any[] = [
        {
            name: 'Geração (kWh)',
            type: 'column',
            data: dados.map((item: any) => ({ x: String(item.dia), y: item.geracao })),
        },
    ];

    if (estimadoDia) {
        series.push({
            name: 'Estimado/dia (kWh)',
            type: 'line',
            data: dados.map((item: any) => ({ x: String(item.dia), y: estimadoDia })),
        });
    }

    const options: any = {
        chart: {
            type: 'line',
            stacked: false,
            toolbar: { show: false },
            zoom: { enabled: false, allowMouseWheelZoom: false },
            animations: { enabled: false },
            events: {
                dataPointSelection: (evento: any, contexto: any, config: any) => {
                    const item = dados[config.dataPointIndex];
                    if (item && onSelecionarDia) onSelecionarDia(item.data);
                },
            },
        },
        plotOptions: { bar: { columnWidth: '70%' } },
        stroke: { width: estimadoDia ? [0, 2] : [0], dashArray: estimadoDia ? [0, 4] : [0] },
        colors: [
            ({ dataPointIndex }: any) => (dados[dataPointIndex]?.data === diaSelecionado ? COR_SELECIONADA : COR_BARRA),
            '#2f80ed',
        ],
        states: {
            hover: { filter: { type: 'darken', value: 0.88 } },
            active: { filter: { type: 'none' } },
        },
        dataLabels: { enabled: false },
        // Um tick por dia: o mês aparece inteiro, com ou sem geração registrada
        xaxis: { tickAmount: dados.length, tickPlacement: 'on', labels: { rotate: 0, style: { fontSize: '10px' } } },
        yaxis: { min: 0, forceNiceScale: true, labels: { formatter: (valor: number) => `${Number(valor).toFixed(0)}` } },
        markers: { size: 0 },
        legend: { show: false },
        tooltip: {
            shared: true,
            y: { formatter: (valor: number) => (valor === null ? 'sem registro' : `${Number(valor).toFixed(2)} kWh`) },
        },
    };

    return (
        <div className="usina-bloco is-clicavel">
            <div className="usina-bloco-header">
                <div className="usina-bloco-titulo">
                    Mês
                    <span className="usina-bloco-hint">clique num dia para ver a curva</span>
                </div>
                <div className="usina-bloco-controles">
                    <span className="usina-bloco-total">{formatarNumero(total)} kWh no mês</span>
                    <button type="button" className="btn btn-sm btn-light btn-outline" onClick={() => onNavegarMes(-1)}>
                        <ChevronLeft size={14} />
                    </button>
                    <span className="usina-bloco-periodo">{nomeMes(referencia.mes)} de {referencia.ano}</span>
                    <button type="button" className="btn btn-sm btn-light btn-outline" onClick={() => onNavegarMes(1)}>
                        <ChevronRight size={14} />
                    </button>
                </div>
            </div>

            <div className="usina-chart-box is-diario">
                {loading
                    ? <div className="usina-vazio">Carregando...</div>
                    : <Chart options={options} series={series} type="line" width="100%" height="100%" />}
            </div>
        </div>
    );
}
